/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiImportOrganisationConfigResponse,
    InternalApiImportOrganisationConfigResponseFromJSON,
    InternalApiImportOrganisationConfigResponseToJSON,
} from '../models';

export interface ExportOrganisationConfigRequest {
    organisationId: number;
}

export interface ExportOrganisationConfigResponse {
    headers: Headers;
    body: Blob;
}

export interface ImportOrganisationConfigRequest {
    file: Blob;
    name: string;
    currency: string;
}

/**
 * 
 */
export class OrganisationCloneInternalApi extends runtime.BaseAPI {

    /**
     * Export organisation configuration
     */
    async exportOrganisationConfigRaw(requestParameters: ExportOrganisationConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
            throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling exportOrganisationConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/organisations/{organisationId}/export`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Export organisation configuration
     */
    async exportOrganisationConfig(requestParameters: ExportOrganisationConfigRequest, initOverrides?: RequestInit): Promise<ExportOrganisationConfigResponse> {
        const response = await this.exportOrganisationConfigRaw(requestParameters, initOverrides);
        return {
          headers: response.raw.headers,
          body: await response.value(),
        };
    }

    /**
     * Import organisation configuration
     */
    async importOrganisationConfigRaw(requestParameters: ImportOrganisationConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiImportOrganisationConfigResponse>> {
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling importOrganisationConfig.');
        }

        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling importOrganisationConfig.');
        }

        if (requestParameters.currency === null || requestParameters.currency === undefined) {
            throw new runtime.RequiredError('currency','Required parameter requestParameters.currency was null or undefined when calling importOrganisationConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name as any);
        }

        if (requestParameters.currency !== undefined) {
            formParams.append('currency', requestParameters.currency as any);
        }

        const response = await this.request({
            path: `/v1/organisations/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiImportOrganisationConfigResponseFromJSON(jsonValue));
    }

    /**
     * Import organisation configuration
     */
    async importOrganisationConfig(requestParameters: ImportOrganisationConfigRequest, initOverrides?: RequestInit): Promise<InternalApiImportOrganisationConfigResponse> {
        const response = await this.importOrganisationConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
